import { render, staticRenderFns } from "./QuestionBase.vue?vue&type=template&id=25bf5c68"
import script from "./QuestionBase.vue?vue&type=script&lang=js"
export * from "./QuestionBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports